import { JSONHover } from "../features/hover";
import YAML from "yaml";
import { MODES } from "../constants";
/**
 * Instantiates a JSONHover instance with the YAML mode
 * @group Codemirror Extensions
 */
export function yamlSchemaHover(options) {
    const hover = new JSONHover(Object.assign(Object.assign({}, options), { parser: YAML.parse, mode: MODES.YAML }));
    return async function jsonDoHover(view, pos, side) {
        return hover.doHover(view, pos, side);
    };
}
